<!--
 * @Author: Gaho
 * @Date: 2024-02-29 14:46:29
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-06 19:55:14
 * @Description: 
-->
<template>
    <ModalTitle
        container-class=""
        :model-value="modelValue"
        :backdrop="backdrop"
        @update:model-value="onModelValue"
        class="corgiwild-modal"
        scopeid="corgiwild-modal-09lo6i59"
    >
        <template #header>
            <span class="text-[24px] leading-10">
                {{ $t('howToPlay') }}
            </span>
        </template>
        <div class="w-full flex flex-col gap-3 text-white">
            <div class="rule-tabbar">
                <RuleDialogTabs 
                    @handleTabChange="handleTabChange" 
                    :currentTab="currentTab"
                />
            </div>
            <div class="rule-content">
                <RuleDialogRules v-if="currentTab === 1"/>
                <RuleDialogPayTable v-else-if="currentTab === 2"/>
                <RuleDialogPaylines v-else-if="currentTab === 3"/>
                <ModalRulesLimitComponent v-else-if="currentTab === 4" />
            </div>
        </div>
        <template #footer>
            <Button class="footer-button" @click="$emit('update:modelValue')">
                <span class="button-text">
                    {{ $t('startPlaying') }}
                </span>
            </Button>
        </template>
    </ModalTitle>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from "vue-i18n";

import RuleDialogTabs from './ruleDialogTabs.vue';
import RuleDialogRules from './dialogRules.vue';
import RuleDialogPayTable from './dialogPayTable.vue';
import RuleDialogPaylines from './dialogPaylines.vue';

export default defineComponent({
    name: 'ruleDialog',
    components: {
        RuleDialogTabs,
        RuleDialogRules,
        RuleDialogPayTable,
        RuleDialogPaylines
    },
    props: {
        modelValue: Boolean,
        backdrop: {
            type: Boolean,
            default: true,
        },
        // rules图片和content数据
        data: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    data(){
        return {
            $t: useI18n().t,
            currentTab: 1
        }
    },
    emits: ['update:modelValue'],
    methods: {
        onModelValue(value){
            this.$emit('update:modelValue', value);
        },
        handleTabChange(item){
            this.currentTab = item.key;
        }
    }
})
</script>

<style lang="scss">
.corgiwild-modal[scopeid="corgiwild-modal-09lo6i59"] .modalHeader{
    width: 100vw;
    max-width: 530px;
}
</style>

<style lang="scss" scoped>
.corgiwild-modal {

}
.rule-tabbar {
    // margin: 0 -24px;
    overflow-x: auto;
    scrollbar-color: #2a3546 rgba(13,19,28,.8);
    scrollbar-width: thin;
    width: 100%;
}
.rule-content {
    overflow: auto;
}
.footer-button {
    font-size: 14px;
    padding-bottom: 4px;
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    -moz-appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    padding: 0;
    position: relative;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    user-select: none;
    height: 44px;
    &::after {
        border-radius: 10px;
        height: 44px;
        background-color: #61001d;
        bottom: 0;
        content: "";
        display: block;
        left: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        z-index: 0;
    }
    .button-text {
        padding-left: 8px;
        padding-right: 8px;
        border-radius: 10px;
        background: linear-gradient(1turn,#c4003b .8%,#fb1949);
        box-shadow: 0 3px 16px #ff234180,inset 0 4px 3px #ffffff4d;
        display: block;
        height: 100%;
        position: relative;
        transition: transform .1s ease-in-out;
        width: 100%;
        z-index: 1;
        font-size: 14px;
        color: white;
        font-variant-numeric: lining-nums tabular-nums;
        font-weight: 600;
        line-height: 44px;
        transform: translateY(-5px);

        &:hover {
            transform: translateY(-8px);
        }
    }
}
</style>